export function initAccordions() {
    const accordionToggle = document.querySelectorAll("[data-toggle-accordion]");

    if (accordionToggle) {
        accordionToggle.forEach(accordion => {
            if (accordion.classList.contains("initialised")) return;

            accordion.classList.add("initialised");

            accordion.addEventListener("click", () => {
                const accordionElement = accordion.closest(".pul-accordion");
                const multipleActiveItems = accordionElement.dataset.multipleActiveItems;
                const isExpanded = accordion.getAttribute("aria-expanded");
                const accordionBody = accordion.parentElement.nextElementSibling;
                const mobileImg = accordion.dataset.mobileImg;
                const desktopImg = accordion.dataset.desktopImg;
                const imageAltText = accordion.dataset.imgAltText;
                const accordionParentElement = accordion.closest(".pul-accordion-block");

                if (mobileImg && desktopImg && imageAltText) {
                    replaceAccordionImage(accordionParentElement, mobileImg, desktopImg, imageAltText);
                }

                // set default image when all accorion items are collapsed
                replaceAccordionDefaultImage(accordionParentElement)

                if (multipleActiveItems === "true") {
                    toggleSingleAccordionItem(accordion, accordionBody, isExpanded);
                } else {
                    toggleAllAccordionItems(accordionElement, accordion, accordionBody, isExpanded);
                }
            });
        });

        function toggleSingleAccordionItem(trigger, accBody, isExpanded) {
            if (isExpanded === "true") {
                trigger.setAttribute("aria-expanded", "false");
                accBody.setAttribute("aria-hidden", "true");

            } else {
                trigger.setAttribute("aria-expanded", "true");
                accBody.setAttribute("aria-hidden", "false");
            }
        }

        function toggleAllAccordionItems(accordionElement, trigger, accBody, isExpanded) {
            const accordionItems = accordionElement.querySelectorAll(".pul-accordion__item");

            // collapse all accordion items
            accordionItems.forEach(item => {
                const button = item.querySelector("[data-toggle-accordion]");
                const body = item.querySelector(".pul-accordion__body");

                button.setAttribute("aria-expanded", "false");
                body.setAttribute("aria-hidden", "true");
            });

            // open clicked accordion item
            toggleSingleAccordionItem(trigger, accBody, isExpanded);
        }
    }
}

function replaceAccordionImage(accordionParentElement, mobileImg, desktopImg, imageAltText) {
    const imageBlock = accordionParentElement.querySelector("picture");

    if (imageBlock) {
        imageBlock.querySelector("img").setAttribute("src", mobileImg);
        imageBlock.querySelector("img").setAttribute("alt", imageAltText);
        imageBlock.querySelector("source").setAttribute("srcset", desktopImg);
    }
}

function replaceAccordionDefaultImage(accordionParentElement) {
    const desktopImg = accordionParentElement.dataset.defaultImgDesktop;
    const mobileImg = accordionParentElement.dataset.defaultImgMobile;
    const altText = accordionParentElement.dataset.defaultImgAlt;
    const imageBlock = accordionParentElement.querySelector("picture");

    setTimeout(() => {
        const expandedItems = accordionParentElement.querySelectorAll("button[aria-expanded='true']").length;

        if (desktopImg && mobileImg && altText && imageBlock && expandedItems === 0) {
            imageBlock.querySelector("img").setAttribute("src", mobileImg);
            imageBlock.querySelector("img").setAttribute("alt", altText);
            imageBlock.querySelector("source").setAttribute("srcset", desktopImg);
        }
    })
}